module.exports = __webpack_public_path__ + "15_pvis_slides.pdf?12b82d6255a19d1edb4b071f3d19c4ae";


//////////////////
// WEBPACK FOOTER
// ./src/assets/paperData/15_pvis_slides.pdf
// module id = 145
// module chunks = 0